import { render, staticRenderFns } from "./OrmDeclineQuoteRequestModal.vue?vue&type=template&id=b5dae9bc&scoped=true"
import script from "./OrmDeclineQuoteRequestModal.vue?vue&type=script&lang=js"
export * from "./OrmDeclineQuoteRequestModal.vue?vue&type=script&lang=js"
import style0 from "./OrmDeclineQuoteRequestModal.vue?vue&type=style&index=0&id=b5dae9bc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5dae9bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5dae9bc')) {
      api.createRecord('b5dae9bc', component.options)
    } else {
      api.reload('b5dae9bc', component.options)
    }
    module.hot.accept("./OrmDeclineQuoteRequestModal.vue?vue&type=template&id=b5dae9bc&scoped=true", function () {
      api.rerender('b5dae9bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/OrmDeclineQuoteRequestModal.vue"
export default component.exports